export class Pesso {
  constructor() {
    return function(input) {
      return (input / 1000).toFixed(3) + '';
    }
  }
}
